import type { ISuitabilityTest } from "@/services/SuitabilityTestsService";

/**
 * El backend engancha la firma al test de Id mayor, y solo si está en DRAFT.
 * El array no viene ordenado, así que la última posición puede ser otro test.
 * Si llega el id del POST, se usa ese borrador. Si no está, el DRAFT de Id mayor.
 */
export function selectDraftSuitabilityTest(
    tests: ISuitabilityTest[] | null | undefined,
    preferredId?: number | null
): ISuitabilityTest | null
{
    const drafts = (tests ?? []).filter((test) => test?.status === "DRAFT" && test.id != null);

    if(preferredId != null)
    {
        const preferred = drafts.find((test) => test.id === preferredId);
        if(preferred)
        {
            return preferred;
        }
    }

    let selected: ISuitabilityTest | null = null;
    drafts.forEach((test) =>
    {
        if(selected == null || (test.id ?? 0) > (selected.id ?? 0))
        {
            selected = test;
        }
    });

    return selected;
}
